import PRODUCT_API from '../../api/product'

// initial state
const state = {
	products: []
}

// getters
const getters = {
	products: state => state.products
}

// actions
const actions = {
	getProducts ({ commit }) {
		console.log('getAllProducts in Product Store')

		PRODUCT_API.fetchProducts(
			data => {
				console.log(data)

				commit('setProducts', data)
			}, e => {
				console.log(e)
			})
	},

	setProducts ({ commit }, products) {
		console.log('Set products')

		commit('setProducts', products)
	},

	resetProducts ({ commit }) {
		console.log('reset in Product Store')

		commit('reset')
	}
}

// mutations
const mutations = {
	setProducts (state, products) {
		state.products = products
	},

	reset (state) {
		state.products = []
	}
}

export default {
	state,
	getters,
	actions,
	mutations
}
